module.exports = __webpack_public_path__ + "static/media/24UHCHR11.2a61297a.jpg";